import React from "react"
import ReactApexChart from "react-apexcharts"

const DonutChart = ({ data = [] }) => {
  // Convert backend data -> chart format
  const labels = data.map(item => item.name)
  // console.log("labels😀😀", labels)

  const series = data.map(item => item.count)

  // console.log("😀😀😀😀appointment data", data)

  const chartOptions = {
    chart: {
      type: "donut",
    },
    // colors: ["#8E7CC3", "#29B6F6", "#E0E0E0", "#66BB6A", "#FFA726"], // add more if needed
    labels: labels,
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      position: "bottom",
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total Appointments",
              formatter: () => series.reduce((a, b) => a + b, 0), // show total
            },
          },
        },
      },
    },
  }

  return (
    <React.Fragment>
      <ReactApexChart
        options={chartOptions}
        series={series}
        type="donut"
        height="300"
      />
    </React.Fragment>
  )
}

export default DonutChart
